// @ts-nocheck
import {
    scroll  
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Footer({
    length, 
    currentPage, 
    setCurrentPage, 
    itemsPerPage, 
    setItemsPerPage, 
    parentId = null,
    paginateAction = null, 
    pageSelectId = null, 
    pa = "position-absolute"
}){
    const pageNumbers = Array.from({length: Math.ceil(length / itemsPerPage)}, (_, i) => (i + 1));
    //------------------------------------------------------
    const paginate = pageNumber => {
        if (typeof paginateAction === 'function') {
            paginateAction();
        }
        setCurrentPage(pageNumber);
        if(parentId) scroll(parentId); else scroll(null);
    };
    //--------------------------------------------------------------------------------------------
    return(
        <footer className = {"w-100 " + pa}>
            <nav className = "d-flex justify-content-end px-4 pt-3">
                <div className = "overflow-auto">
                <ul className = "pagination mb-0 d-flex cssPage">
                    {pageNumbers.map(pageNumber => (
                    <li key = {pageNumber} className = "page-item">
                        <button
                            type = "button"
                            onClick = {() => paginate(pageNumber)}
                            style = {{
                                background:
                                currentPage === pageNumber?
                                "#e9ecef":null
                            }}
                            className = "page-link paginationOutline"
                        >
                            {pageNumber}
                        </button>
                    </li> 
                    ))}
                </ul>
                </div>
            </nav>
            <div className = "text-nowrap mt-3 pe-4 d-flex justify-content-end align-items-center">
                <span>Total: {length}</span>
                <select id = {"pageSelect " + (pageSelectId ?? "main")} className = "form-select d-inline pageNumberSelectWidth ms-3" value = {itemsPerPage} onChange = {e => {
                    setCurrentPage(1);
                    setItemsPerPage(e.currentTarget.value);
                    scroll(null);
                }}>
                    <option>1</option>
                    <option>5</option>
                    <option>10</option>
                    <option>20</option>
                    <option>50</option>
                    <option>100</option>
                </select>
            </div>
        </footer>
    )
}
